<div class="pdf-image-preview">
  <!-- Display image when loaded -->
  <img *ngIf="hasImage()"
       [src]="safeImageUrl"
       (load)="onImageLoad()"
       (error)="onImageError()"
       alt="PDF Image">

  <!-- Loading indicator -->
  <div *ngIf="isLoadingImage" class="image-placeholder">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Loading...</span>
  </div>

  <!-- Placeholder when no image or error -->
  <div *ngIf="!safeImageUrl && !isLoadingImage" class="image-placeholder">
    <mat-icon>image</mat-icon>
    <span *ngIf="!filePath">Select image</span>
    <span *ngIf="filePath && imageLoadError" class="error-text">Failed to load</span>
  </div>
</div>
